import { render, staticRenderFns } from "./AddRestrictedDate.vue?vue&type=template&id=213d3996&"
import script from "./AddRestrictedDate.vue?vue&type=script&lang=js&"
export * from "./AddRestrictedDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports